// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2qJyc","requiredAsterisk":"Info_requiredAsterisk__Z9o2h"};